// =============================================================================
// Analytics Configuration — Single source of truth for all tracking IDs
// =============================================================================
//
// All GA4 and Google Ads IDs live here. Update this file when configuring new
// properties or switching measurement IDs.
//
// Google Ads conversion note:
// Set the conversion window to 30 days in Google Ads admin. Median
// time-to-conversion is ~8–10 days with a long tail (trial → recovery email →
// discount code path can take days or weeks). A shorter window would
// significantly undercount ROAS.
// =============================================================================

type BrandConfig = {
  ga4MeasurementId: string;
  googleAdsConversionId: string;
  googleAdsConversions: {
    // Primary conversion — Google Ads optimises toward this
    paymentCompleted: { label: string };
    // Secondary conversion — micro-conversion signal, important early when purchase volume is low
    registrationSubmitted: { label: string };
  };
  // Domains that should be linked for cross-domain tracking (marketing site ↔ app)
  crossDomainLinkerDomains: string[];
};

type AnalyticsConfig = {
  camdeed: BrandConfig;
  tuokis: BrandConfig;
};

export const analyticsConfig: AnalyticsConfig = {
  camdeed: {
    ga4MeasurementId: "G-MZRQ6FBQ3H", // Reusing the Camdeed Landing one
    googleAdsConversionId: "AW-CAMDEED_ID", // TODO: Replace with actual Google Ads conversion ID
    googleAdsConversions: {
      paymentCompleted: { label: "CAMDEED_PAYMENT_LABEL" }, // TODO: Replace with actual label
      registrationSubmitted: { label: "CAMDEED_REGISTRATION_LABEL" }, // TODO: Replace with actual label
    },
    crossDomainLinkerDomains: ["camdeed.com", "camdeed.app"],
  },
  tuokis: {
    ga4MeasurementId: "G-MPV631033E", // Reusing the Tuokis Landing one
    googleAdsConversionId: "AW-TUOKIS_ID", // TODO: Replace when Tuokis runs ads
    googleAdsConversions: {
      paymentCompleted: { label: "TUOKIS_PAYMENT_LABEL" }, // TODO: Replace with actual label
      registrationSubmitted: { label: "TUOKIS_REGISTRATION_LABEL" }, // TODO: Replace with actual label
    },
    crossDomainLinkerDomains: ["tuokis.com", "tuokis.lt", "tuokis.app"],
  },
};
